module.exports = __webpack_public_path__ + "img/partner_img20.32ad9057.png";